/* eslint-disable react/no-array-index-key,react/jsx-no-target-blank */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import { LoadableResponsiveImage as ResponsiveImage } from '../../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalPartnerInstitutions.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class PortalPartnerInstitutions extends React.Component {
  static displayName = 'PortalPartnerInstitutions';

  static propTypes = {
    anchor: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    partners: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        institutionLogoImage: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  };

  render() {
    const { anchor, title, partners } = this.props;

    return (
      <portal-partner-institutions id={anchor}>
        <div className="row portal-section">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <h2>{title}</h2>
            <div className="row partner-institutions">
              {partners.map((partner, i) => (
                <div
                  key={`partner_${i}`}
                  className={classNames({
                    'columns large-3 medium-4 small-6 xsmall-12': true,
                    end: i === partners.size - 1,
                  })}
                >
                  <a href={partner.get('url')} target="_Blank">
                    <ResponsiveImage
                      responsive
                      background
                      src={partner.get('institutionLogoImage')}
                      onResize="up"
                      resizeWidthOnly
                    />
                  </a>
                  <div className="partner-name">{partner.get('name')}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </portal-partner-institutions>
    );
  }
}
